module.exports = __webpack_public_path__ + "img/print.465ed6b9.jpg";